/**
 * Tanzania mikoa (regions) and wilaya (districts) for branch addresses.
 * Data aligned with TAMISEMI / NBS administrative areas (mainland + Zanzibar, 31 regions).
 * @see frontend/src/data/tanzaniaRegions.json
 */

import regionsData from '../data/tanzaniaRegions.json';

export const TANZANIA_REGIONS = regionsData;

export const getDistrictsByRegion = (regionId) => {
  const region = TANZANIA_REGIONS.find((r) => r.id === regionId);
  return region?.districts || [];
};

export const getRegionName = (regionId) => {
  const region = TANZANIA_REGIONS.find((r) => r.id === regionId);
  return region?.name || '';
};

export const getDistrictName = (regionId, districtId) => {
  const district = getDistrictsByRegion(regionId).find((d) => d.id === districtId);
  return district?.name || '';
};

/** True when district belongs to the selected region (for validation). */
export const isDistrictInRegion = (regionId, districtId) => {
  if (!regionId || !districtId) return false;
  return getDistrictsByRegion(regionId).some((d) => d.id === districtId);
};

/** Legacy IDs saved before this update — map to current district id where renamed. */
const LEGACY_DISTRICT_IDS = {
  'arusha-dist': 'arusha-district',
  'dodoma-dist': 'dodoma-district',
  'geita-dist': 'geita-district',
  'iringa-dist': 'iringa-district',
  'iringa-city': 'iringa-city',
  'mbeya-dist': 'mbeya-district',
  'mwanza-city': 'nyamagana',
  'mwanza-dist': 'ilemela',
  'njombe-dist': 'njombe-district',
  'lindi-dist': 'lindi-district',
  'mtwara-dist': 'mtwara-district',
  'morogoro-dist': 'morogoro-district',
  'shinyanga-dist': 'shinyanga-district',
  'singida-dist': 'singida-district',
  'tabora-dist': 'tabora-city',
  'tanga-dist': 'tanga-city',
  'moshi': 'moshi-city',
  'moshi-dist': 'moshi-district',
};

export const resolveDistrictId = (regionId, districtId) => {
  if (!districtId) return '';
  if (isDistrictInRegion(regionId, districtId)) return districtId;
  const mapped = LEGACY_DISTRICT_IDS[districtId];
  if (mapped && isDistrictInRegion(regionId, mapped)) return mapped;
  return districtId;
};

export const getDistrictNameResolved = (regionId, districtId) => {
  const id = resolveDistrictId(regionId, districtId);
  return getDistrictName(regionId, id) || districtId || '';
};
